import { useCart } from "../components/Cart/CartContext.jsx";
import { useState } from "react";
import Header from "../components/Layout/Header.jsx";
import { useNavigate } from "react-router-dom";
import VideoUploadStatus from "../components/Modals/VideoUploadStatus.jsx";

export default function Customize() {
  const { cart, updateCustomization, removeSingleUnit } = useCart();
  const navigate = useNavigate();
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(false);
  // const total = cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

async function handleVideoUpload(e, itemId, index) {
  const file = e.target.files[0];
  if (!file) return;
  if (file.size > 20 * 1024 * 1024) {
    alert("Video is too large. Max size is 20MB.");
    return;
  }

  const safeFileName = `${Date.now()}_${file.name.replace(/\s+/g, "_")}`;
  const formData = new FormData();
  formData.append("video", file);
  formData.append("filename", safeFileName);

  setUploading(true);
  setUploadProgress(0);
  setUploadComplete(false);

  try {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://wildcard.introducingjeffrey.com/php/uploadVideo.php");

    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percent = Math.round((event.loaded / event.total) * 100);
        setUploadProgress(percent);
      }
    };

    xhr.onload = () => {
      const result = JSON.parse(xhr.responseText);
      if (result.success) {
        updateCustomization(itemId, index, {
          ...(cart.find(p => p.id === itemId)?.customization?.[index] || {}),
          video: result.url,
        });
        setUploadComplete(true);
      } else {
        alert("❌ Upload failed: " + result.message);
      }
      setUploading(false);
    };

    xhr.onerror = () => {
      alert("❌ Upload error.");
      setUploading(false);
    };

    xhr.send(formData);
  } catch (err) {
    console.error("Upload error:", err);
    setUploading(false);
  }
}


  return (
    <>
      <Header />
      <div className="checkout-container">
        <div>
          <p><strong>Let's get personal!</strong></p>
          <p>The {totalItems} {totalItems > 1 ? "cards" : "card"} below can be customized. We'll review and checkout on the next step.</p>
        </div>

        {cart.flatMap((item) =>
          Array.from({ length: item.quantity }, (_, i) => {
            const customization = item.customization?.[i] || {};
            const videoUrl = customization.video;

    return (
      <div className="checkout-card" key={`${item.id}-${i}`}>
        <div className="checkout-media">
          <div className="checkout-img-wrapper">
            <img src={item.imageUrl} alt={item.UITitle} className="checkout-img" />
          </div>
          <button className="remove-btn" onClick={() => removeSingleUnit(item.id)}>
            Remove This Item
          </button>
        </div>

        <div className="checkout-card-body">
          <h4>{item.UITitle} — ${item.price.toFixed(2)}</h4>

          {!item.customName && !item.customVideo && (
            <p className="review-line"><em>No customization options available.</em></p>
          )}

          {item.customName && (
            <>
              <label>Who is this card for?</label>
              <input
                type="text"
                placeholder="enter a name"
                className="checkout-input"
                value={customization.recipientName || ""}
                onChange={(e) => {
                    updateCustomization(item.id, i, {
                        ...customization,
                        recipientName: e.target.value,
                    });
                }}
              />
            </>
          )}

          {item.customEmail && (
            <>
              <label>Send card to this email:</label>
              <input
                type="email"
                placeholder="recipient email"
                className="checkout-input"
                value={customization.recipientEmail || ""}
                onChange={(e) => {
                    updateCustomization(item.id, i, {
                        ...customization,
                        recipientEmail: e.target.value,
                    });
                }}
              />
            </>
          )}

          {item.customVideo && (
            <>
              <p>Add a video message:</p>

              {videoUrl && (
                <div style={{ marginBottom: "0.5rem", fontSize: "0.9rem", color: "green" }}>
                  ✅ Video uploaded!{" "}
                  <button
                    style={{
                      marginLeft: "0.5rem",
                      fontSize: "0.85rem",
                      background: "none",
                      border: "none",
                      color: "#0077cc",
                      cursor: "pointer",
                      textDecoration: "underline"
                    }}
                    onClick={() => {
                      setPreviewUrl(videoUrl);
                      setShowPreviewModal(true);
                    }}
                  >
                    ▶ Preview
                  </button>
                </div>
              )}

              <label className="wizard-button" style={{ cursor: "pointer" }}>
                {videoUrl ? "Replace Video" : "Choose Video"}
                <input
                  type="file"
                  accept="video/mp4,video/quicktime,video/3gpp"
                  style={{ display: "none" }}
                  onChange={(e) => handleVideoUpload(e, item.id, i)}
                />
              </label>

              <button className="wizard-button" disabled style={{ opacity: 0.5 }}>
                Create Video
              </button>
            </>
          )}
        </div>
      </div>
    );
  })
)}


        <div>
          <button className="wizard-button" onClick={() => navigate("/checkout")}>
            Review & Checkout
          </button>
        </div>

        <VideoUploadStatus
          uploading={uploading}
          progress={uploadProgress}
          completed={uploadComplete}
          onCancel={() => window.location.reload()}
          onClose={() => {
            setUploading(false);
            setUploadProgress(0);
            setUploadComplete(false);
          }}
        />


        {showPreviewModal && previewUrl && (
          <div className="modal-wrapper" onClick={() => setShowPreviewModal(false)}>
            <div className="modal-shell" onClick={(e) => e.stopPropagation()}>
              <video
                src={previewUrl}
                controls
                style={{ maxWidth: "100%", borderRadius: "8px" }}
              />
              <button
                className="wizard-button"
                style={{ marginTop: "1rem" }}
                onClick={() => setShowPreviewModal(false)}
              >
                Close Preview
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
